var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39892 3.23223C2.86776 2.76339 3.50365 2.5 4.16669 2.5H10C10.6631 2.5 11.2989 2.76339 11.7678 3.23223C12.2366 3.70107 12.5 4.33696 12.5 5V6.66667C12.5 7.1269 12.1269 7.5 11.6667 7.5C11.2064 7.5 10.8334 7.1269 10.8334 6.66667V5C10.8334 4.77899 10.7456 4.56702 10.5893 4.41074C10.433 4.25446 10.221 4.16667 10 4.16667H4.16669C3.94567 4.16667 3.73371 4.25446 3.57743 4.41074C3.42115 4.56702 3.33335 4.77899 3.33335 5V15C3.33335 15.221 3.42115 15.433 3.57743 15.5893C3.73371 15.7455 3.94567 15.8333 4.16669 15.8333H10C10.221 15.8333 10.433 15.7455 10.5893 15.5893C10.7456 15.433 10.8334 15.221 10.8334 15V13.3333C10.8334 12.8731 11.2064 12.5 11.6667 12.5C12.1269 12.5 12.5 12.8731 12.5 13.3333V15C12.5 15.663 12.2366 16.2989 11.7678 16.7678C11.2989 17.2366 10.6631 17.5 10 17.5H4.16669C3.50365 17.5 2.86776 17.2366 2.39892 16.7678C1.93008 16.2989 1.66669 15.663 1.66669 15V5C1.66669 4.33696 1.93008 3.70107 2.39892 3.23223ZM8.92261 6.91074C9.24805 7.23618 9.24805 7.76382 8.92261 8.08926L7.8452 9.16667H16.6667C17.1269 9.16667 17.5 9.53976 17.5 10C17.5 10.4602 17.1269 10.8333 16.6667 10.8333H7.8452L8.92261 11.9107C9.24805 12.2362 9.24805 12.7638 8.92261 13.0893C8.59717 13.4147 8.06953 13.4147 7.7441 13.0893L5.2441 10.5893C4.91866 10.2638 4.91866 9.73618 5.2441 9.41074L7.7441 6.91074C8.06953 6.58531 8.59717 6.58531 8.92261 6.91074Z",
    fill: "#DBFF00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.1d9f158319247088c7f4291a9ed5a934.svg";
export { ForwardRef as ReactComponent };